const topics = [
  { label: '顶流恋情实锤', heat: 3, isNew: false },
  { label: '综艺争议名场面', heat: 2, isNew: false },
  { label: '明星离婚内幕', heat: 1, isNew: true },
  { label: '网红人设崩塌', heat: 3, isNew: false },
  { label: '电视剧删减片段', heat: 1, isNew: false },
  { label: '音乐节冲突事件', heat: 2, isNew: false },
  { label: '品牌代言人更换', heat: 1, isNew: true },
  { label: '选秀节目黑幕曝光', heat: 1, isNew: false },
  { label: '明星素颜对比热帖', heat: 2, isNew: false },
  { label: '直播带货翻车合集', heat: 1, isNew: true },
  { label: '跨年晚会阵容泄露', heat: 2, isNew: false },
];

function HeatDots({ level }: { level: number }) {
  return (
    <span className="inline-flex gap-0.5 ml-1.5">
      {Array.from({ length: level }).map((_, i) => (
        <span key={i} className="w-1 h-1 rounded-full bg-primary-500"></span>
      ))}
    </span>
  );
}

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">热门话题</h2>
          <span className="text-xs text-foreground-400">实时热度追踪</span>
        </div>

        <div className="flex flex-wrap gap-2 md:gap-3">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#topics"
              className="group inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full border border-background-300 bg-background-50 hover:bg-primary-50 hover:border-primary-200 transition-colors cursor-pointer"
            >
              {topic.isNew && (
                <span className="text-[10px] font-bold text-primary-600 bg-primary-100 px-1.5 py-0.5 rounded-full whitespace-nowrap">NEW</span>
              )}
              <span className="text-sm text-foreground-700 group-hover:text-primary-700 transition-colors whitespace-nowrap">{topic.label}</span>
              <HeatDots level={topic.heat} />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}